import type { CampaignOwnerAccent } from './campaign'

/**
 * The campaign's audit trail.
 *
 * Two kinds of entry share one shape: things a person did and things the
 * sequence did on its own. Keeping them in one feed is the point — "who changed
 * the send rate" and "why did 12 messages fail" are the same question at 3am.
 */

/** Who the entry is attributed to. `null` means the system acted by itself. */
export interface CampaignActivityActor {
  name: string
  accent: CampaignOwnerAccent
}

export const CAMPAIGN_ACTIVITY_TONES = {
  /** Ordinary entry. */
  neutral: 'neutral',
  /** Something is waiting on a person. */
  attention: 'attention',
  /** A failure worth chasing. */
  failure: 'failure',
} as const

export type CampaignActivityTone =
  (typeof CAMPAIGN_ACTIVITY_TONES)[keyof typeof CAMPAIGN_ACTIVITY_TONES]

export interface CampaignActivityEntry {
  id: string
  /** "4:38 PM", "Aug 2, 9:00 AM" — already in the reader's timezone. */
  time: string
  /** Omitted for system entries, which render the neutral dot instead. */
  actor?: CampaignActivityActor
  title: string
  detail: string
  tone?: CampaignActivityTone
}

/** A day's worth of entries under one band. */
export interface CampaignActivityGroup {
  key: string
  /** "UPCOMING", "THURSDAY, JUL 31". */
  label: string
  entries: CampaignActivityEntry[]
}
